/*
  Beauvyn premium GUIDE PAGE template
  File: assets/bv-guide-page.js

  Adapted from the Beauvyn blog template.
  Does NOT modify or depend on bv-article.js.
*/

(() => {

  function normaliseText(value) {

    return value
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  }


  function slugify(value) {

    return value
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  }


  function createTocLink(heading) {

    const listItem =
      document.createElement("li");

    const link =
      document.createElement("a");


    link.href =
      `#${heading.id}`;


    link.textContent =
      heading.dataset.tocLabel ||
      heading.textContent.trim();


    listItem.appendChild(link);


    return {
      listItem,
      link
    };

  }



  /*
    Move FIRST Page content image into the hero.
  */





  /*
    Count Rich Text takeaway list items so the
    teal number circle still works.
  */

  function updateTakeawayCount(guide) {

    const counter =
      guide.querySelector(
        "[data-bv-takeaway-count]"
      );


    if (!counter) {
      return;
    }


    const items =
      guide.querySelectorAll(
        ".bv-key-takeaways__content li"
      );


    if (!items.length) {
      return;
    }


    counter.textContent =
      String(items.length);


    counter.setAttribute(
      "aria-label",
      `${items.length} key takeaways`
    );


    counter.hidden = false;

  }



  /*
    Mobile-safe tables.
  */

  function wrapTables(content) {
  content.querySelectorAll("table").forEach((table) => {

    /*
      Shopify Pages often create every table cell as <td>,
      including the first/header row.

      Convert the first row into real <th> cells so the
      Beauvyn table styling works exactly like the blog.
    */

    const firstRow = table.querySelector("tr");

    if (firstRow) {
      const firstRowCells = Array.from(
        firstRow.querySelectorAll("td")
      );

      firstRowCells.forEach((cell) => {
        const headingCell = document.createElement("th");

        headingCell.innerHTML = cell.innerHTML;
        headingCell.setAttribute("scope", "col");

        Array.from(cell.attributes).forEach((attribute) => {
          if (attribute.name !== "style") {
            headingCell.setAttribute(
              attribute.name,
              attribute.value
            );
          }
        });

        cell.replaceWith(headingCell);
      });
    }


    /*
      Wrap table so it can scroll horizontally on mobile.
    */

    const existingWrapper = table.closest(".bv-table-wrap");

    if (existingWrapper) {
      return;
    }

    const wrapper = document.createElement("div");

    wrapper.className = "bv-table-wrap";

    table.parentNode.insertBefore(wrapper, table);

    wrapper.appendChild(table);

  });
}



  /*
    Same Beauvyn Quick Check behaviour as blog.
  */

  function addQuickCheckStyles(content) {

    content
      .querySelectorAll("p")
      .forEach((paragraph) => {


        const paragraphText =
          paragraph.textContent
            .trim()
            .toLowerCase();


        if (
          paragraphText.startsWith(
            "look for a clear statement such as"
          ) ||
          paragraphText.startsWith(
            "pouch price ÷"
          ) ||
          paragraphText.startsWith(
            "pouch price /"
          ) ||
          paragraphText.startsWith(
            "quick check:"
          )
        ) {

          paragraph.classList.add(
            "bv-quick-check"
          );

        }

      });

  }



  /*
    Same heading preparation as Beauvyn blogs.
  */

  function prepareHeadings(
    content,
    pageTitle
  ) {

    let headings =
      Array.from(
        content.querySelectorAll("h2")
      );


    /*
      Hide an exact duplicate H2 if somebody
      repeats the Page title inside the content.
    */

    if (headings.length > 0) {

      const firstHeadingText =
        normaliseText(
          headings[0].textContent
        );


      const pageTitleText =
        normaliseText(pageTitle);


      if (
        firstHeadingText &&
        pageTitleText &&
        firstHeadingText === pageTitleText
      ) {

        headings[0].hidden = true;

        headings =
          headings.slice(1);

      }

    }



    headings.forEach(
      (heading, index) => {


        const originalText =
          heading.textContent.trim();


        heading.dataset.tocLabel =
          originalText;



        /*
          Same numbered H2 syntax as your blogs:

          1. Heading
          2. Heading
          3) Heading
        */

        const numberedHeading =
          originalText.match(
            /^(\d+)[.)]\s+(.+)$/
          );


        if (numberedHeading) {

          const sectionNumber =
            numberedHeading[1];


          const headingText =
            numberedHeading[2];


          heading.dataset.sectionNumber =
            sectionNumber;


          heading.classList.add(
            "bv-numbered-heading"
          );


          heading.innerHTML = "";


          const numberElement =
            document.createElement("span");


          numberElement.className =
            "bv-heading-number";


          numberElement.setAttribute(
            "aria-hidden",
            "true"
          );


          numberElement.textContent =
            String(sectionNumber)
              .padStart(2, "0");


          const textElement =
            document.createElement("span");


          textElement.className =
            "bv-heading-text";


          textElement.textContent =
            headingText;


          heading.append(
            numberElement,
            textElement
          );

        }



        if (!heading.id) {

          const baseId =
            slugify(originalText) ||
            `page-section-${index + 1}`;


          let uniqueId =
            baseId;


          let suffix =
            2;


          while (
            document.getElementById(
              uniqueId
            )
          ) {

            uniqueId =
              `${baseId}-${suffix}`;


            suffix += 1;

          }


          heading.id =
            uniqueId;

        }

      }
    );


    return headings;

  }



  /*
    Build desktop + mobile TOCs.
  */

  function buildTableOfContents(
    guide,
    headings
  ) {

    const desktopToc =
      guide.querySelector(
        "[data-bv-desktop-toc]"
      );


    const mobileToc =
      guide.querySelector(
        "[data-bv-mobile-toc]"
      );


    const desktopLinks =
      new Map();


    if (desktopToc) {
      desktopToc.innerHTML = "";
    }


    if (mobileToc) {
      mobileToc.innerHTML = "";
    }



    headings.forEach((heading) => {


      if (heading.hidden) {
        return;
      }


      if (desktopToc) {

        const desktopItem =
          createTocLink(heading);


        desktopToc.appendChild(
          desktopItem.listItem
        );


        desktopLinks.set(
          heading.id,
          desktopItem.link
        );

      }



      if (mobileToc) {

        const mobileItem =
          createTocLink(heading);


        mobileToc.appendChild(
          mobileItem.listItem
        );

      }

    });


    return desktopLinks;

  }



  /*
    Active desktop TOC heading.
  */

  function observeCurrentHeading(
    headings,
    desktopLinks
  ) {

    if (
      !(
        "IntersectionObserver"
        in window
      ) ||
      desktopLinks.size === 0
    ) {

      return;

    }


    const observer =
      new IntersectionObserver(

        (entries) => {


          const visibleEntries =
            entries
              .filter(
                (entry) =>
                  entry.isIntersecting
              )
              .sort(
                (
                  firstEntry,
                  secondEntry
                ) =>
                  firstEntry
                    .boundingClientRect
                    .top -
                  secondEntry
                    .boundingClientRect
                    .top
              );


          if (
            visibleEntries.length === 0
          ) {

            return;

          }


          desktopLinks.forEach(
            (link) => {

              link.classList.remove(
                "is-active"
              );

            }
          );


          const activeHeading =
            visibleEntries[0].target;


          const activeLink =
            desktopLinks.get(
              activeHeading.id
            );


          if (activeLink) {

            activeLink.classList.add(
              "is-active"
            );

          }

        },

        {
          rootMargin:
            "-18% 0px -68% 0px",

          threshold: 0
        }

      );


    headings.forEach(
      (heading) => {

        observer.observe(heading);

      }
    );

  }



  /*
    [[BEAUVYN_PRODUCT]]
  */

  function placeInlineProduct(
    guide,
    content
  ) {

    const productCard =
      guide.querySelector(
        "[data-bv-inline-product]"
      );


    if (!productCard) {
      return;
    }


    const marker =
      content.querySelector(
        "[data-bv-product-marker]"
      );


    if (!marker) {

      productCard.hidden = true;

      return;

    }


    const markerWrapper =
      marker.closest("p");


    if (markerWrapper) {

      markerWrapper.replaceWith(
        productCard
      );

    } else {

      marker.replaceWith(
        productCard
      );

    }


    productCard.hidden = false;


    productCard.removeAttribute(
      "aria-hidden"
    );

  }



  function initialiseGuide(guide) {

    if (
      guide.dataset.bvInitialised ===
      "true"
    ) {

      return;

    }


    guide.dataset.bvInitialised =
      "true";


    const content =
      guide.querySelector(
        "[data-bv-article-content]"
      );


    if (!content) {
      return;
    }


    /*
      Move first Shopify Page image to hero.
    */

   


    /*
      Count rich-text key takeaways.
    */

    updateTakeawayCount(
      guide
    );


    const pageTitle =
      guide.dataset.pageTitle || "";


    const headings =
      prepareHeadings(
        content,
        pageTitle
      );


    wrapTables(content);


    addQuickCheckStyles(
      content
    );


    const desktopLinks =
      buildTableOfContents(
        guide,
        headings
      );


    placeInlineProduct(
      guide,
      content
    );


    observeCurrentHeading(
      headings,
      desktopLinks
    );

  }



  function initialiseAllGuides() {

    document
      .querySelectorAll(
        "[data-beauvyn-guide]"
      )
      .forEach(
        initialiseGuide
      );

  }



  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialiseAllGuides
    );

  } else {

    initialiseAllGuides();

  }



  document.addEventListener(
    "shopify:section:load",
    initialiseAllGuides
  );

})();